import { render, staticRenderFns } from "./welcomeTime.vue?vue&type=template&id=1315df8f"
import script from "./welcomeTime.vue?vue&type=script&lang=js"
export * from "./welcomeTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports